import React, { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

export default function ScrollToTopButton({ hasBottomNav = false }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 360);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!isVisible) return null;

  return (
    <button
      type="button"
      onClick={scrollToTop}
      className={`fixed right-4 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-[#d8bd68] text-[#1a1918] shadow-lg shadow-black/15 transition-all hover:bg-[#e5ce80] active:scale-95 ${
        hasBottomNav
          ? 'bottom-[calc(env(safe-area-inset-bottom)+5.25rem)]'
          : 'bottom-[calc(env(safe-area-inset-bottom)+1.25rem)]'
      }`}
      aria-label="Voltar para o topo"
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
}
